import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import SearchBox from '../SearchBox';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

const ButtonSearchBoxActionBar = (props) => {
  const {
    openCreateDialog,
    searchTerm,
    handleSearchTermChange,
    buttonText,
    searchPlaceholder,
    hideCreate
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.actionBar}>
      <Grid container spacing={3}>
        <Grid xs={2} item>
          <Button
            color="primary"
            variant="contained"
            disabled={hideCreate}
            onClick={() => openCreateDialog(true)}
          >
            {buttonText}
          </Button>
        </Grid>
        <Grid xs={10} item>
          <SearchBox
            className={classes.searchBox}
            handleSearchTermChange={handleSearchTermChange}
            searchTerm={searchTerm}
            placeholder={searchPlaceholder}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ButtonSearchBoxActionBar;
